/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ico-ceiling': {
    width: 16,
    height: 16,
    viewBox: '0 0 300 300',
    data: '<path pid="0" d="M238 136h-36a6 6 0 00-6 6v18a24 24 0 0021.76 23.89 33 33 0 01-65.52 0A24 24 0 00174 160v-18a6 6 0 00-6-6h-16V83.91A24 24 0 00174 60v-8a6 6 0 00-6-6h-36a6 6 0 00-6 6v8a24 24 0 0022 23.91V136h-16a6 6 0 00-6 6v18a24 24 0 0021.76 23.89 33 33 0 01-65.52 0A24 24 0 00104 160v-18a6 6 0 00-6-6H62a6 6 0 00-6 6v18a24 24 0 0022.21 23.93A37 37 0 00148 196.7V232l-6.59 6.59a2 2 0 000 2.82l7.18 7.18a2 2 0 002.82 0l7.18-7.18a2 2 0 000-2.82L152 232v-35.3a37 37 0 0069.79-12.77A24 24 0 00244 160v-18a6 6 0 00-6-6zM134 60v-6h32v6a16 16 0 01-32 0zM64 160v-16h32v16a16 16 0 01-32 0zm70 0v-16h32v16a16 16 0 01-32 0zm102 0a16 16 0 01-32 0v-16h32z"/>'
  }
})
